import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GamesSharedModule } from '@games/games-shared/games-shared.module';
import { GameButtonComponent } from '@new-core/components/buttons-game/game-button/game-button.component';
import { GameInputComponent } from '@new-core/components/inputs-gi/game-input/game-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { FitTextModule, FormFieldModule, TimerModule } from '@shared/components/games';
import { CalculatorModule } from '@shared/components/games/calculator/calculator.module';
import { NumberMemoryControllerComponent } from './number-memory-controller/number-memory-controller.component';
import { NumberMemoryCorrectAnswerPreviewComponent } from './number-memory-preview/number-memory-answer-preview/number-memory-answer-preview.component';
import { NumberMemoryExamplePreviewComponent } from './number-memory-preview/number-memory-example-preview/number-memory-example-preview.component';
import { NumberMemoryParametersPreviewComponent } from './number-memory-preview/number-memory-parameters-preview/number-memory-parameters-preview.component';
import { NumberMemoryUserAnswerPreviewComponent } from './number-memory-preview/number-memory-user-answer-preview/number-memory-user-answer-preview.component';
import { NumberMemorySettingsComponent } from './number-memory-settings/number-memory-settings.component';
import { NumberMemoryRulesComponent } from './tools/number-memory-rules/number-memory-rules.component';
import { CalculatorLayoutComponent } from '@shared/components/games/input-layouts/calculator-layout/calculator-layout.component';

@NgModule({
  declarations: [
    NumberMemoryControllerComponent,
    NumberMemorySettingsComponent,
    NumberMemoryRulesComponent,
    NumberMemoryExamplePreviewComponent,
    NumberMemoryCorrectAnswerPreviewComponent,
    NumberMemoryParametersPreviewComponent,
    NumberMemoryUserAnswerPreviewComponent,
  ],
  exports: [
    NumberMemoryControllerComponent,
    NumberMemorySettingsComponent,
    NumberMemoryRulesComponent,
    NumberMemoryExamplePreviewComponent,
    NumberMemoryCorrectAnswerPreviewComponent,
    NumberMemoryParametersPreviewComponent,
    NumberMemoryUserAnswerPreviewComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    FitTextModule,
    TimerModule,
    FormFieldModule,
    GamesSharedModule,
    GameButtonComponent,
    GameInputComponent,
    CalculatorModule,
    CalculatorLayoutComponent,
  ],
})
export class NumberMemoryModule {}
